import React from 'react';
import { Dialog, makeStyles, DialogContent, Box } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import logoImg from '../../img/logo.png';

interface Props {
    isOpen: boolean;
}

const useStyles = makeStyles((theme) => ({
    spinner: {
        background: 'transparent',
        color: 'black',
        width: '100px',
        height: '100px',
    },
    dialog: {
        padding: '0px',
    },
    dialogContent: {
        marginTop: '30%',
        textAlign: 'center',
        background: 'white',
        height: '300px',
    },
    logo: {
        marginRight: 'auto',
        marginLeft: 'auto',
        background: `url(${logoImg}) `,
        width: '395px',
        height: '125px',
        backgroundSize: '395px 125px',
        marginBottom: '50px',
    },
}));

const Loading: React.FC<Props> = (props) => {
    const { isOpen } = props;
    const classes = useStyles();

    return (
        <Dialog
            fullScreen
            open={isOpen}
            className={classes.dialog}
            PaperProps={{
                style: {
                    backgroundColor: 'white',
                    boxShadow: 'none',
                },
            }}
        >
            <DialogContent className={classes.dialogContent}>
                <Box className={classes.logo} />
                <CircularProgress className={classes.spinner} size="80px" />
            </DialogContent>
        </Dialog>
    );
};

export default Loading;
